export default __webpack_public_path__ + "static/media/Pistol_3.ded2564d.png";